import React from "react";
import { Link } from "@quintype/components";
import { object, array, bool, string, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../../atoms/Headline";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";
import More from "../../../atoms/More";
import { getSlug, getCollectionName } from "../../../utils/utils";
import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";
import { staticTexts } from "../../../utils/Translate";

import "./organism1.m.css";

const Organism1 = ({
  collection,
  sections,
  showCollectionName,
  showLoadMoreButton,
  publisherAttributes,
  src,
  updatedFont = false,
  domainSlug,
  storiesToLoad,
  widths = [400],
}) => {
  const stories =
    collection && collection.items
      ? collection.items.filter((item) => item.type === "story").slice(0, storiesToLoad)
      : null;
  const allStories =
      collection && collection.items
        ? collection.items.filter((item) => item.type === "story")
        : null;

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const headlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";

  const renderListStories =
    stories.length > 1 &&
    stories.slice(1, storiesToLoad).map((item, index) => (
      <div styleName={`${stories.length > storiesToLoad ? "list-story " : "list-story custom-border"}`} key={index}>
        <Link key={index} href={item.story.url}>
          <Headline text={item.story.headline} headlineType={21} headerLevel={2} styleName={headlineStyle} />
        </Link>
      </div>
    ));

  return stories && stories.length > 0 ? (
    <div styleName="collection-wrapper" className="collection-wrapper">
      <div>
        {showCollectionName && (
          <CollectionTitleWithArrow
            collectionName={collectionName}
            collectionSlug={collectionSlug}
            headlineClassName="collection-name-arrow"
            updatedFont={updatedFont}
          />
        )}
        {stories[0] && (
          <div styleName="top-story">
            <CustomStoryCard4
              story={stories[0].story}
              headlineType={21}
              widths={widths}
              updatedFont={updatedFont}
              src={src}
            />
          </div>
        )}
      </div>
      {renderListStories}
      {!showLoadMoreButton && allStories.length > storiesToLoad && (
        <div styleName={`read-more-button ${publisherAttributes.lang === "en" ? "en-read-more-button" : ""}`}>
          <More type="read-more" collection={collection} text={staticTexts(publisherAttributes.lang).loadMore} />
        </div>
      )}
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

Organism1.propTypes = {
  collection: object,
  sections: array,
  showCollectionName: bool,
  showLoadMoreButton: bool,
  publisherAttributes: object,
  src: string,
  updatedFont: bool,
  domainSlug: string,
  storiesToLoad: number,
  widths: array,
};

export default connect(mapStateToProps)(Organism1);
